module.exports = __webpack_public_path__ + "static/grandfather-granddaughter-mountain-biking.5434e768.webp";